import React from 'react'


const Footer = () => {
    return(
        <div style={{width:"100%", height:"77px",backgroundColor:'#02291F',
        display:"flex", alignItems:'center', justifyContent:"center"
        }}>
            <span style={{color:"white", fontSize:'15px'}}>
                © 2021 Audemars Piguet
            </span>
        </div>
    )
}

export default Footer